<template>
  <div id="MeetingListTable">
    <el-table :data="dataList" border @row-click="rowClick">
      <el-table-column type="index" :label="$tx('hygl.hyyt.index','序号')" align="center"></el-table-column>
      <el-table-column
v-for="(col, index) in tableColumns"
                       :key="index"
                       :prop="col.prop"
                       :label="col.label"
                       :align="col.align"
                       :width="col.width"
      >
        <template slot-scope="scope">
          <span v-if="['beginTime', 'endTime'].includes(scope.column.property)">{{ scope.row[scope.column.property] | dateFormat }}</span>
          <span v-else-if="scope.column.property === 'status'">{{ statusFormat(scope.row[scope.column.property] ) }}</span>
          <span v-else>{{ scope.row[scope.column.property] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
const moment = require('moment')

export default {
    filters: {
        dateFormat(date) {
            return moment(new Date(date)).format('YYYY-MM-DD HH:mm')
        }
    },
    props: {
        dataList: { type: Array, require: true, default: () => [] }
    },
    data() {
        return {
            tableColumns: [
                { prop: 'beginTime', label: this.$tx('hygl.hyyt.meetingStartTime', '会议开始时间'), align: 'center', width: '150' },
                { prop: 'endTime', label: this.$tx('hygl.hyyt.meetingEndTime', '会议结束时间'), align: 'center', width: '150' },
                { prop: 'meetSubjedt', label: this.$tx('hygl.hyyt.conferenceTheme', '会议主题'), align: 'left' },
                { prop: 'meetName', label: this.$tx('hygl.hyyt.meetingName', '会议室名称'), align: 'center', width: '200' },
                { prop: 'applayName', label: this.$tx('hygl.hyyt.appointedBy', '预约人'), align: 'center', width: '120' },
                { prop: 'phone', label: this.$tx('hygl.hyyt.phone', '联系方式'), align: 'center', width: '150' },
                { prop: 'numPeople', label: this.$tx('hygl.hyyt.numPeople', '会议人数'), align: 'center', width: '100' },
                { prop: 'status', label: this.$tx('hygl.hyyt.scheduled', '预定状态'), align: 'center', width: '100' }
            ]
        }
    },
    methods: {
        statusFormat(status) {
            const statusText = {
                0: this.$tx('hygl.hyyt.isCancel', '已取消'),
                1: this.$tx('hygl.hyyt.isReserved', '已预订'),
                2: this.$tx('hygl.hyyt.isApplying', '申请中'),
                3: this.$tx('hygl.hyyt.applyingPass', '申请通过'),
                4: this.$tx('hygl.hyyt.applyingNoPass', '申请不通过')
            }
            return statusText[status] || ''
        },
        rowClick(row, column, event) {
            // approve：1 直接预定  0 申请
            console.log(row)
            const _this = this
            if (row.approve === 1) {
                const moduleInfo = {'formTemplate': 'dcontent/busiformurl?vwtype=W&url=/hygl/meeting/form.html', 'winWidth': 1000, 'delUrl': 'hygl/meeting/delete', 'addNewUrl': 'hygl/meeting/addNew', 'insertUrl': 'hygl/meeting/insert', 'moduleCode': 'meeting', 'listAdvSearchExpandPanel': 0, 'winHeight': 600, 'updateUrl': 'hygl/meeting/update', 'listDataUrl': 'hygl/meeting/listdata', 'getByIdUrl': 'hygl/meeting/getById', 'listAdvSearchAllFields': 0, 'openViewType': '0'}
                moduleInfo.room = row
                const openPage = window.open('#/mr?voId=' + row.id + '&moduleInfo=' + encodeURIComponent(JSON.stringify(moduleInfo)) + '&title=' + encodeURIComponent('会议通知') + '&moduleTitle=' + encodeURIComponent('会议管理') + '&busiInfo=' + encodeURIComponent('会议通知') + '&formUrl=hygl.meeting.form_newForm&innerUrl=&noEdit=false&canEdit=1')
                const loop = setInterval(() => {
                    if (openPage && openPage.closed) {
                        _this.$vnode.context.getSiteData()
                        clearInterval(loop)
                    }
                }, 1500)
            } else if (row.approve === 0) {
                window.open(`#/wflow?wfEngineUrl=hygl/roomApply&busiDataId=${row.id}`)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
#MeetingListTable{

}
</style>
